var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3001_118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.707 5.63585L20.364 11.2929C20.5515 11.4804 20.6568 11.7347 20.6568 11.9999C20.6568 12.265 20.5515 12.5193 20.364 12.7069L14.707 18.3639C14.5184 18.546 14.2658 18.6468 14.0036 18.6445C13.7414 18.6423 13.4906 18.5371 13.3052 18.3517C13.1198 18.1663 13.0146 17.9155 13.0123 17.6533C13.01 17.3911 13.1108 17.1385 13.293 16.9499L17.243 12.9999H4C3.73478 12.9999 3.48043 12.8945 3.29289 12.707C3.10536 12.5194 3 12.2651 3 11.9999C3 11.7346 3.10536 11.4803 3.29289 11.2927C3.48043 11.1052 3.73478 10.9999 4 10.9999H17.243L13.293 7.04985C13.1975 6.95761 13.1213 6.84726 13.0689 6.72526C13.0165 6.60325 12.9889 6.47204 12.9877 6.33926C12.9866 6.20648 13.0119 6.0748 13.0622 5.9519C13.1125 5.829 13.1867 5.71735 13.2806 5.62346C13.3745 5.52957 13.4861 5.45531 13.609 5.40503C13.7319 5.35475 13.8636 5.32945 13.9964 5.3306C14.1292 5.33176 14.2604 5.35934 14.3824 5.41175C14.5044 5.46416 14.6148 5.54034 14.707 5.63585Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3001_118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowWhite);
export default __webpack_public_path__ + "static/media/right-arrow-white.f5eee19bc06701460c550603fbb7a53a.svg";
export { ForwardRef as ReactComponent };